import React from 'react';
import ReferenceInput, { getChildrenProps } from './ReferenceInput';
import { AutocompleteInput } from 'react-admin';

const EhrSystemInput = (props) => (
  <ReferenceInput {...props}>
    <AutocompleteInput
      optionText="label"
      {...getChildrenProps(props)}
      data-testid="ehr-system-input"
    />
  </ReferenceInput>
);

EhrSystemInput.defaultProps = {
  label: 'EHR System',
  reference: 'EhrSystem',
  source: 'ehr_system_id',
  sort: { field: 'label', order: 'ASC' },
};

export default EhrSystemInput;
